import React from 'react'
import { useNavigate } from 'react-router-dom';

const TabManagement = ({ tabs, setTabName, tabName }) => {
  const navigate = useNavigate();
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
  return (
    <div className='w-[40%] sm:w-[10%]'>
      <div className="sm:hidden max-sm:pb-[15px]">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          onChange={(e)=>{setTabName(e.target.value); if(e.target.value === "Account View"){navigate("/Account")}else{navigate("/Lead-Management")}}}
          id="tabs"
          name="tabs"
          className="block max-sm:w-[106%] rounded-md border-gray-300 max-sm:px-2.5 max-sm:py-0.5 py-2 pl-3 pr-10 text-base focus:border-gray-300 focus:outline-none focus:ring-white sm:text-sm"
          defaultValue={tabs.find((tab) => tab.current).name}
        >
          {tabs.map((tab) => (
            <option key={tab.name} value={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {tabs.map((tab) => (
              <div
                key={tab.name}
                // href={tab.href}
                onClick={() => {
                  setTabName(tab.name)
                  navigate(tab.href)
                }}
                className={classNames(
                  tabName == tab.name 
                    ? 'border-[var(--brand-primary)] text-gray-900'
                    : 'border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-700',
                  'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium cursor-pointer'
                )}
                aria-current={tab.current ? 'page' : undefined}
              >
                {tab.name}
              </div>
            ))}
          </nav>
        </div>
      </div>
          </div>
  )
}

export default TabManagement;